import styled from "styled-components";
import { FullHeightGrid } from "./FullHeightGrid";
export const ColumnGrid = styled(FullHeightGrid) `
  grid-template-columns: ${props => props.$template_columns};
`;
